import React, { Fragment } from "react"; 
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1-sapsup.jpg",
  heading: "SAP Solutions & Support",
  description: `Our SAP Solutions & Support services ensure your SAP systems operate efficiently, securely, and continuously aligned with your business objectives. 
  We provide comprehensive assistance including implementation guidance, system monitoring, issue resolution, upgrades, and user training. 
  Our experienced SAP consultants help maximize the value of your SAP investment, ensuring optimal system performance, stability, and seamless business processes.`,

  middleImage: "/images/service/sr-d-1-2.jpg",
  features: [
    "End-to-End SAP Implementation & Support",
    "24/7 System Monitoring & Maintenance",
    "Performance Tuning, Upgrades & Patch Management",
    "User Training & Functional Consulting",
    "Custom SAP Module Assistance"
  ],

  challengeHeading: "Challenges in SAP Solutions & Support",
  challengeParagraphs: [
    `Managing complex SAP environments requires expertise across multiple modules, continuous monitoring, and rapid problem resolution. 
    Downtime or misconfigurations can severely impact business operations.`,
    `Our SAP experts provide proactive monitoring, quick incident response, and strategic guidance to maintain system stability, enhance performance, and support business continuity.`
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg"
  ]
};

const SapSolutionsSupport = () => (
  <Fragment>
    <Seo
      title="SAP Solutions & Support | Tech Ayukta"
      description="Tech Ayukta provides comprehensive SAP Solutions & Support services to optimize, maintain, and enhance SAP environments for organizations."
      keywords="SAP Solutions, SAP Support, SAP Consulting, SAP Maintenance, Tech Ayukta"
      canonical="https://www.techayukta.com/services/sap-solutions-support"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="SAP Solutions & Support"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default SapSolutionsSupport;
